import React from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { fetchServer } from '../Base/modelManager'
import { message, Modal } from "antd";

class InfoGeoloc extends React.Component {

    onGeolocAsked = (event) => {
        event.preventDefault();
        Modal.confirm({
            title: 'Confirmation',
            content: 'Êtes-vous sûr de vouloir demander à être contacté par le service commercial ?',
            okText: 'Oui',
            cancelText: 'Annuler',
            onOk: () => {
                const request = {
                    endPoint: this.props.apiUrl + '/Services/Clients/requestGeolocContact',
                    method: 'POST',
                    params: {
                        clientid: this.props.currentClient.uid,

                    },
                    token: this.props.JWTToken
                }

                fetchServer(request,
                    () => message.info('Le service commercial a été notifié. Vous serez contacté dans les plus brefs délais.', 5),
                    (error) => message.error(error.message, 10))
            }
        })    

    }

    noGeoloc = () => {
        return (
            <div>
                <br />
                <br />
                <p>
                    Vous ne disposez pas d'offre de géolocalisation.
                </p>
                <p>
                    Si vous souhaitez des informations sur la géolocalisation cliquez <Link onClick={this.onGeolocAsked}>ICI</Link> pour être rappelé
                </p>
            </div>)
    }

    axodel = () => {
        return (
            <div>
                <br />
                <br />
                <p>
                    cliquez <Link target="_blank" to="https://www.free2move-connectfleet.com/">ICI</Link> pour accéder à votre espace dédié
                </p>

            </div>)
    }

    quartix = () => {
        return (
            <div>
                <br />
                <br />
                <p>
                    cliquez <Link target="_blank" to="https://www.quartix.com/fr-fr/connexion/">ICI</Link>pour accéder à votre espace dédié
                </p>

            </div>)
    }


    render() {

        return (
            <div className="col-xl-6 col-md-6 aos-init aos-animate">
                <div className="HomeBlock graphic">
                    <p className='HomeBlockTitle'>- MA GEOLOCALISATION -</p>
                    <div style={{ height: '80%', width: '80%', margin: 'auto' }}>
                        {
                            this.props.isAxodel === false && this.props.isQuartix === false ?
                                this.noGeoloc()
                                : <>
                                    {this.props.isAxodel === true ? this.axodel() : null}
                                    {this.props.isQuartix === true ? this.quartix() : null}
                                </>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

InfoGeoloc.propTypes = {
    isAxodel: PropTypes.bool,
    isQuartix: PropTypes.bool,
    JWTToken: PropTypes.string,
    apiUrl: PropTypes.string,
    currentClient: PropTypes.object
};

const mapStateToProps = (state) => {
    return ({
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
        currentClient: state.authentication.currentClient,

    })
}



export default connect(mapStateToProps)(InfoGeoloc);
